import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="mb-4">
              <img
                src="https://static.readdy.ai/image/15419bedb578ec59343dd2ae27ec91d5/bcd8c2dce83612dc3328f52b56b1caf2.png"
                alt="兄弟維修 Logo"
                className="h-12 w-auto object-contain"
                style={{ filter: 'drop-shadow(0 0 8px rgba(255,255,255,0.25))' }}
              />
            </div>
            <p className="text-sm leading-relaxed text-gray-400 mb-6">
              專業手機、平板、筆電維修服務。使用原廠規格零件，提供快速、可靠、有保障的維修體驗。
            </p>
            <div className="flex items-center gap-3">
              <a href="https://www.facebook.com/people/Brotherfix-%E5%85%84%E5%BC%9F%E7%B6%AD%E4%BF%AE/100087359506181/" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-800 hover:bg-orange-500 transition-colors cursor-pointer text-gray-300 hover:text-white">
                <i className="ri-facebook-fill text-base" />
              </a>
              <a href="https://www.instagram.com/brotherfix_1990/" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-800 hover:bg-orange-500 transition-colors cursor-pointer text-gray-300 hover:text-white">
                <i className="ri-instagram-line text-base" />
              </a>
              <a href="https://lin.ee/mOf6eFn" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center rounded-full bg-gray-800 hover:bg-orange-500 transition-colors cursor-pointer text-gray-300 hover:text-white">
                <i className="ri-line-fill text-base" />
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">維修項目</h4>
            <ul className="space-y-2.5">
              {[
                { label: 'iPhone 維修', path: '/services/iphone' },
                { label: 'iPad 維修', path: '/services/ipad' },
                { label: 'Mac 維修', path: '/services/mac' },
                { label: 'Android 維修', path: '/services' },
                { label: '手機資料救援', path: '/services/data-recovery' },
                { label: '常見問題', path: '/faq' },
              ].map((s) => (
                <li key={s.label}>
                  <Link to={s.path} className="text-gray-400 hover:text-orange-400 text-sm transition-colors cursor-pointer">
                    {s.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">快速連結</h4>
            <ul className="space-y-2.5">
              <li><Link to="/about" className="text-gray-400 hover:text-orange-400 text-sm transition-colors cursor-pointer">關於兄弟維修</Link></li>
              <li><Link to="/pricing" className="text-gray-400 hover:text-orange-400 text-sm transition-colors cursor-pointer">維修價格查詢</Link></li>
              <li><Link to="/news" className="text-gray-400 hover:text-orange-400 text-sm transition-colors cursor-pointer">最新消息</Link></li>
              <li><Link to="/cases" className="text-gray-400 hover:text-orange-400 text-sm transition-colors cursor-pointer">維修案例</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-orange-400 text-sm transition-colors cursor-pointer">聯絡我們</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">聯絡資訊</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-map-pin-line text-orange-400 text-sm" />
                </div>
                <a href="https://maps.app.goo.gl/xdHXYXwKyD6nhfdP8" target="_blank" rel="noopener noreferrer" className="text-gray-400 text-sm hover:text-orange-400 transition-colors cursor-pointer">台北市萬華區萬大路251號</a>
              </li>
              <li className="flex items-center gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-orange-400 text-sm" />
                </div>
                <span className="text-gray-400 text-sm">0916-858-251</span>
              </li>
              <li className="flex items-center gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-orange-400 text-sm" />
                </div>
                <span className="text-gray-400 text-sm">(02) 2305-1647</span>
              </li>
              <li className="flex items-center gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-line-fill text-orange-400 text-sm" />
                </div>
                <a href="https://lin.ee/mOf6eFn" target="_blank" rel="nofollow noopener noreferrer" className="text-gray-400 hover:text-orange-400 text-sm transition-colors cursor-pointer">加入官方 LINE</a>
              </li>
              <li className="flex items-start gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 flex-shrink-0">
                  <i className="ri-time-line text-orange-400 text-sm" />
                </div>
                <span className="text-gray-400 text-sm">週一至週六 13:00–22:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-xs">© 2025 手機維修中心. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <span className="text-gray-500 text-xs hover:text-gray-300 cursor-pointer">隱私權政策</span>
            <span className="text-gray-600">·</span>
            <span className="text-gray-500 text-xs hover:text-gray-300 cursor-pointer">服務條款</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
